import { ReduxAction } from 'types/redux';
import { SUBSCRIPTION, CANCEL_SUBSCRIPTION } from "../../constants/subscription.constants";

const initialState = {
  loading: false,
  data: {},
  error: '',
};

export function subscription(state = initialState, action: ReduxAction) {
  switch (action.type) {
    case SUBSCRIPTION.REQUEST:
      return {
        ...state,
        loading: true,
        data: {},
        error: '',
      };
    case SUBSCRIPTION.SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.subscription,
        error: '',
      };
    case SUBSCRIPTION.FAILURE:
      return {
        ...state,
        loading: false,
        data: {},
        error: action.error,
      };

    case CANCEL_SUBSCRIPTION.REQUEST:
      return {
        ...state,
        loading: true,
        data: {},
        error: '',
      };
    case CANCEL_SUBSCRIPTION.SUCCESS:
      return {
        ...state,
        loading: false,
        data: {},
        error: '',
      };
    case CANCEL_SUBSCRIPTION.FAILURE:
      return {
        ...state,
        loading: false,
        data: {},
        error: action.error,
      };
    default:
      return state;
  }
}
